// extracted by mini-css-extract-plugin
export default {"sidebar":"LabDetailsLayout_sidebar__h7we7","navLink":"LabDetailsLayout_navLink__hsKI+","active":"LabDetailsLayout_active__beC8K","labContent":"LabDetailsLayout_labContent__Gnq55"};